import { ShiftsReferenceContractFragment } from 'generated/resources/graphql'
import type moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

export interface Props {
  id: number | null | undefined
  jobTitle: string | null | undefined
  jobCatalogName: string | undefined
  jobCatalogRoleName: string | undefined
  workingHours: number | null | undefined
  workingHoursFrequency: string | null | undefined
  workingWeekDays: string | null | undefined
  endsOn: string | null | undefined
  fragment: ShiftsReferenceContractFragment
}

class ReferenceContract {
  id: number
  jobTitle: string
  jobCatalogName: string
  jobCatalogRoleName: string
  workingHours: number
  workingHoursFrequency: string
  workingWeekDays: string
  endsOn: string | null | undefined
  fragment: ShiftsReferenceContractFragment

  constructor(props: Props) {
    this.id = props.id || 0
    this.jobTitle = props.jobTitle || ''
    this.jobCatalogName = props.jobCatalogName || ''
    this.jobCatalogRoleName = props.jobCatalogRoleName || ''
    this.workingHours = props.workingHours || 0
    this.workingHoursFrequency = props.workingHoursFrequency || ''
    this.workingWeekDays = props.workingWeekDays || ''
    this.endsOn = props.endsOn

    this.fragment = props.fragment
  }

  get contractEndDate(): moment.Moment | null | undefined {
    return this.endsOn ? stringToDate(this.endsOn, 'backend') : null
  }

  static buildFromGraphQL(fragment: ShiftsReferenceContractFragment): ReferenceContract {
    return new ReferenceContract({
      id: fragment.id,
      jobTitle: fragment.jobTitle,
      jobCatalogName: fragment.jobCatalogLevel?.name,
      jobCatalogRoleName: fragment.jobCatalogLevel?.roleName,
      workingHours: fragment.workingHours,
      workingHoursFrequency: fragment.workingHoursFrequency,
      workingWeekDays: fragment.workingWeekDays,
      endsOn: fragment.endsOn,
      fragment,
    })
  }
}

export default ReferenceContract
